import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import useAsyncModifyList from '../../../../hooks/useAsyncModifyList';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { ContactListFilterItem } from '../../../../sic-lib/types/ContactListFilterItem';
import { ListItem } from '../../../../sic-lib/types/Lists';
import { buildUpdateListRequest } from '../../../../sic-lib/utils/contactListHelpers';
import ButtonLoading from '../../../Shared/ButtonLoading';

const useStyles = makeStyles()({
    paper: {
        width: '100%',
    },
});

type Props = {
    isOpen: boolean;
    listItem: ListItem;
    listFilters?: ContactListFilterItem[];
    listContacts?: number[];
    onCloseHandler: () => void;
};

export default function DialogConfirmUpdateGroup({
    isOpen,
    listItem,
    listFilters,
    listContacts,
    onCloseHandler,
}: Props) {
    const { classes } = useStyles();

    const { requestStatus, asyncModifyList } = useAsyncModifyList();

    const handleSubmit = async () => {
        const list = buildUpdateListRequest({
            ...listItem,
            ...{ filters: listFilters || [] },
        });

        await asyncModifyList(list);

        onCloseHandler();
    };

    return (
        <Dialog
            maxWidth="xs"
            aria-labelledby="dialog_update_group"
            open={isOpen}
            PaperProps={{
                className: classes.paper,
            }}
        >
            <DialogTitle id="dialog_update_group">Update Group</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" align="center">
                    Current list settings will be overwritten
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onCloseHandler}>
                    Cancel
                </Button>
                <ButtonLoading
                    isLoading={requestStatus === RequestStatus.active}
                    onClick={handleSubmit}
                    color="secondary"
                    variant="outlined"
                >
                    Ok
                </ButtonLoading>
            </DialogActions>
        </Dialog>
    );
}
